import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../assets/styles/AboutUsCoreValue.css";

const AboutUsCoreValues = () => {
  return (
    <section className="aboutuscorSection">
      <Container>
        <h2 className="aboutuscorTitle">OUR CORE VALUES</h2>
        <p className="aboutuscorSubtitle">
          We dedicatedly master the power of technology in bespoke ways for our customers, guided by three core values:
        </p>
        <Row className="aboutuscorValues">
          <Col md={4} sm={12} className="aboutuscorBox">
            <h3 className="aboutuscorHeading">Integrity</h3>
            <p className="aboutuscorText">Embody dependability, honesty, and transparency.</p>
          </Col>
          <Col md={4} sm={12} className="aboutuscorBox">
            <h3 className="aboutuscorHeading">Innovation</h3>
            <p className="aboutuscorText">Act courageously, experiment, and make bold decisions.</p>
          </Col>
          <Col md={4} sm={12} className="aboutuscorBox">
            <h3 className="aboutuscorHeading">Dedication</h3>
            <p className="aboutuscorText">Commit to tirelessly delivering precision and perfection.</p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUsCoreValues;
